import React from "react";
import { AlertCircle } from "lucide-react";

type SnapLayerHeroProps = {
  title?: string;
  subtitle?: string;
  showDevelopmentNotice?: boolean;
};

const SnapLayerHero: React.FC<SnapLayerHeroProps> = ({
  title = "Welcome to SnapLayer",
  subtitle = "Bulk image personalization and image automation for reusable templates, links, and workflows.",
  showDevelopmentNotice = false,
}) => {
  return (
    <div className="hero-gradient border-b border-sl-surface-2">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-5xl mx-auto flex flex-col items-center gap-8 text-center">
          <div className="flex items-center justify-center">
            <img
              src="/brand/snaplayer-wordmark-transparent.png"
              alt="SnapLayer"
              className="max-w-full h-16 md:h-20 lg:h-24 object-contain drop-shadow"
            />
          </div>

          <div className="space-y-3">
            <p className="text-lg md:text-xl font-semibold text-slate-100">
              The Next Generation in Bulk Image Personalization
            </p>
            {title && (
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight bg-gradient-to-r from-sl-accent to-sl-primary bg-clip-text text-transparent">
                {title}
              </h1>
            )}
            <p className="text-base md:text-lg text-slate-200">
              {subtitle}
            </p>
          </div>

          {showDevelopmentNotice && (
            <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 max-w-2xl w-full">
              <div className="flex items-start gap-3">
                <AlertCircle className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <div className="text-left">
                  <p className="text-sm font-medium text-blue-300 mb-1">
                    Software in Active Development
                  </p>
                  <p className="text-sm text-sl-muted">
                    SnapLayer is improving continuously in active development. You may see updates as we ship quickly. Please share bugs and feedback with the widget in the lower right corner or email us at{" "}
                    <a
                      href="mailto:support@getsnaplayer.com"
                      className="text-sl-accent hover:underline"
                    >
                      support@getsnaplayer.com
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SnapLayerHero;
